import styled from 'styled-components'
import { t } from 'ttag'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { vagRundFont } from '@h2/components/mixins'
import { Button } from '@h2/components/buttons/button'
import { PG30S } from '@h2/components/colors'

const BackButton = styled(Button)`
  ${vagRundFont};
  font-weight: 300;
  color: ${PG30S};
  svg {
    margin-right: 5px;
  }

  @media (${features.minWidth.laptop}) {
    align-self: flex-end;
  }
`
const Back = ({ onClick = () => {} }) => {
  return (
    <BackButton variant="link" onClick={onClick}>
      <FontAwesomeIcon size="sm" icon={faChevronLeft} />
      {t`Back to previous step`}
    </BackButton>
  )
}

Back.propTypes = {
  onClick: PropTypes.func
}

export { Back }
